import { cnActionTypes } from '../actions/cnActions';

const CNReducers = (state = { }, action) => {
  switch (action.type) {
  case cnActionTypes.GET_CN.LOADING: {
    const { getCNLoading } = action;
    return {
      ...state,
      getCNLoading,
    };
  }
  case cnActionTypes.GET_CN.SUCCESS: {
    const { creditNotes } = action;
    return {
      ...state,
      creditNotes,
    };
  }
  case cnActionTypes.GET_CN_BY_ID.LOADING: {
    const { getCNByIdLoading } = action;
    return {
      ...state,
      getCNByIdLoading,
    };
  }
  case cnActionTypes.GET_CN_BY_ID.SUCCESS: {
    const { selectedCN } = action;
    return {
      ...state,
      selectedCN,
    };
  }
  case cnActionTypes.CREATE_CN.LOADING: {
    const { createCNLoading } = action;
    return {
      ...state,
      createCNLoading,
    };
  }
  case cnActionTypes.UPDATE_CN.LOADING: {
    const { updateCNLoading } = action;
    return {
      ...state,
      updateCNLoading,
    };
  }
  case cnActionTypes.UPDATE_STATUS_CN.LOADING: {
    const { updateCNStatusLoading } = action;
    return {
      ...state,
      updateCNStatusLoading,
    };
  }
  case cnActionTypes.DELETE_CN.LOADING: {
    const { deleteCNLoading } = action;
    return {
      ...state,
      deleteCNLoading,
    };
  }
  case cnActionTypes.UPDATE_CN_WORKFLOW_STEP.LOADING: {
    const { updateCNWorkflowStepLoading } = action;
    return {
      ...state,
      updateCNWorkflowStepLoading,
    };
  }
  case cnActionTypes.LINK_PAYMENT_TO_CN.LOADING: {
    const { linkPaymentToCnLoading } = action;
    return {
      ...state,
      linkPaymentToCnLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default CNReducers;
